import Vue from 'vue'

//-- Restor de Código .vue
import VueRouter from 'vue-router'
import SVC00000 from '@/igs-vistas/SVC00000.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SVC00000',
    component: SVC00000
  },
  {
    path: '/00801',
    name: 'SVC00801',
    component: () => import('@/igs-vistas/SVC00801.vue')
  },
  {
    path: '/11000',
    name: 'SVC11000',
    component: () => import('@/igs-vistas/SVC11000.vue')
  },
  {
    path: '/11616',
    name: 'SVC11616',
    component: () => import('@/igs-vistas/SVC11616.vue')
  },
  {
    path: '/91000',
    name: 'SVC91000',
    component: () => import('@/igs-vistas/SVC91000.vue')
  },
  {
    path: '/91010',
    name: 'SVC91010',
    component: () => import('@/igs-vistas/SVC91010.vue')
  },
  {
    path: '/92000',
    name: 'SVC92000',
    component: () => import('@/igs-vistas/SVC92000.vue')
  },
  {
    path: '/95000',
    name: 'SVC95000',
    component: () => import('@/igs-vistas/SVC95000.vue')
  },
  {
    path: '/95010',
    name: 'SVC95010',
    component: () => import('@/igs-vistas/SVC95010.vue')
  },
  {
    path: '/99000',
    name: 'SVC99000',
    component: () => import('@/igs-vistas/SVC99000.vue')
  },
  {
    path: '/99010',
    name: 'SVC99010',
    component: () => import('@/igs-vistas/SVC99010.vue')
  }
]

const igs_routes = new VueRouter({
  routes,
  mode: 'abstract'
  //mode: 'abstract',
  //base: process.env.BASE_URL
})

export default igs_routes
